(() => {
  if (!customElements.get("product-videos")) {
    class ProductVideos extends HTMLElement {
      constructor() {
        super();
        this.currentIndex = 0;
        this.videoList = [];
        this.popup = null;
        this.iframeWrapper = null;
      }

      connectedCallback() {
        this.items = this.querySelectorAll(".video-item");
        this.collectVideoList();
        this.createPopup();
        this.bindEvents();
      }

      collectVideoList() {
        this.videoList = Array.from(this.items).map((item) => item.dataset.videoUrl);
      }

      createPopup() {
        if (document.querySelector("#video-popup")) return;
        const popup = document.createElement("div");
        popup.id = "video-popup";
        popup.innerHTML = `
          <div class="video-overlay" data-video-overlay></div>
          <div class="video-content">
            <div class="video-close" data-video-close>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.07109 1.07105L15.2132 15.2132M15.2129 1.07104L1.0708 15.2132" stroke="#454142" stroke-width="1.5"/>
                </svg>
            </div>
            <div class="video-iframe-wrapper">
              <div class="video-iframe" data-video-iframe></div>
            </div>
          </div>
        `;
        document.body.appendChild(popup);

        this.popup = popup;
        this.iframeWrapper = popup.querySelector("[data-video-iframe]");
        this.closeBtn = popup.querySelector("[data-video-close]");
        this.overlay = popup.querySelector("[data-video-overlay]");

        this.closeBtn.addEventListener("click", () => this.closePopup());
      }

      getVideoUrlForDevice(item) {
        const desktopUrl = item.dataset.videoUrl;
        const mobileUrl = item.dataset.videoMobileUrl;
        const isMobile = window.innerWidth <= 768;

        if (isMobile && mobileUrl) {
          return mobileUrl; 
        }

        return desktopUrl;
      }

      bindEvents() {
        if (!this.items.length) return;

        this.items.forEach((item, index) => {
          item.addEventListener("click", () => {
            this.currentIndex = index;
            this.currentItem = item;

            const url = this.getVideoUrlForDevice(item);

            this.openPopup(url);
          });
        });
      }

      openPopup(url) {
        this.renderVideo(url);
        this.popup.classList.add("active");
        document.body.style.overflow = "hidden";
        
        // Apply mobile 9:16 ratio class if needed (only for non-YouTube videos)
        const isYouTube = url.includes("youtube.com") || url.includes("youtu.be");
        const hasMobileRatio = this.currentItem && this.currentItem.hasAttribute("data-mobile-9-16-ratio");
        
        if (hasMobileRatio) {
          this.popup.classList.add("mobile-9-16-ratio");
        }
      }

      renderVideo(url) {
        this.iframeWrapper.innerHTML = "";

        if (url.includes("youtube.com") || url.includes("youtu.be")) {
          const videoId = this.getYouTubeEmbedUrl(url);
          const iframeId = "yt-player-" + Date.now();

          const iframeContainer = document.createElement("div");
          iframeContainer.id = iframeId;
          iframeContainer.style.width = "100%";
          iframeContainer.style.height = "100%";
          this.iframeWrapper.appendChild(iframeContainer);

          this.initYouTubeAPI(videoId, iframeId);
        } else {
          const video = document.createElement("video");
          video.src = url;
          video.controls = true;
          //   video.muted = true;
          video.autoplay = true;
          video.playsInline = true;
          video.style.width = "100%";
          video.style.height = "100%";

          video.addEventListener("ended", () => this.playNextVideo());
          this.iframeWrapper.appendChild(video);

          //   video.play().catch(err => console.log("Autoplay blocked:", err));
        }
      }

      playNextVideo() {
        this.currentIndex = (this.currentIndex + 1) % this.videoList.length;
        this.currentItem = this.items[this.currentIndex];

        const url = this.getVideoUrlForDevice(this.currentItem);

        this.renderVideo(url);

        const isYouTube = url.includes("youtube.com") || url.includes("youtu.be");
        const hasMobileRatio = this.currentItem.hasAttribute("data-mobile-9-16-ratio");

        this.popup.classList.remove("mobile-9-16-ratio");
        if (hasMobileRatio) {
          this.popup.classList.add("mobile-9-16-ratio");
        }
      }

      closePopup() {
        this.popup.classList.remove("active");
        this.popup.classList.remove("mobile-9-16-ratio");
        this.iframeWrapper.innerHTML = "";
        document.body.style.overflow = "";
      }

      getYouTubeEmbedUrl(url) {
        let videoId = "";
        if (url.includes("youtube.com")) {
          if (url.includes("shorts/")){
            videoId = url.split('shorts/')[1];
          } else {
            const params = new URL(url).searchParams;
            videoId = params.get("v");
          }
        } else if (url.includes("youtu.be")) {
          videoId = url.split("/").pop();
        }
        return videoId;
      }

      initYouTubeAPI(videoId, elementId) {
        const onReady = () => {
          this.ytPlayer = new YT.Player(elementId, {
            videoId: videoId,
            playerVars: {
              autoplay: 1,
              // mute: 1,
              playsinline: 1,
              rel: 0,
              modestbranding: 1,
            },
            events: {
              onStateChange: (event) => {
                if (event.data === YT.PlayerState.ENDED) {
                  this.playNextVideo();
                }
              },
            },
          });
        };

        if (typeof YT === "undefined" || typeof YT.Player === "undefined") {
          const tag = document.createElement("script");
          tag.src = "https://www.youtube.com/iframe_api";
          document.body.appendChild(tag);
          window.onYouTubeIframeAPIReady = onReady;
        } else {
          onReady();
        }
      }
    }

    customElements.define("product-videos", ProductVideos);
  }
})();
